export const advantageList = [
  {
    icon: '/icons/settings.svg',
    name: 'Гибкость',
    text: 'Реализуем бизнес-задачи с помощью дружественных пользователю интерфейсов на базе аналитики.',
  },
  {
    icon: '/icons/settings.svg',
    name: 'Качество',
    text: 'Реализуем бизнес-задачи с помощью дружественных пользователю интерфейсов на базе аналитики.',
  },
  {
    icon: '/icons/settings.svg',
    name: 'Гибкость',
    text: 'Реализуем бизнес-задачи с помощью дружественных пользователю интерфейсов на базе аналитики.',
  },
];
